import { Link } from '@solidjs/meta';

export function KiwiMaru()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Kiwi+Maru&display=swap' rel='stylesheet' />
	</>);
}
